/* eslint-disable react/style-prop-object */
import React, { useContext, useState } from "react";
import Searchbar from "../../../../Helpers/Searchbar/Searchbar";
import trans from "../../../../../utils";
import { filtrationcontext } from "../../../../../context/Filtercontext";
import { InputSelect } from "../../../../Helpers/Input/RefactoredInput";
import { useGetAllformsQuery } from "../../../../../Redux/service/Forms/Form";
import { useGetAllTasksQuery } from "../../../../../Redux/service/Tasks/Tasks";
import { useGetAllPOIsQuery } from "../../../../../Redux/service/POIS/POIs";
import { useGetChildUsersQuery } from "../../../../../Redux/service/Users/Users";
import { useSelector } from "react-redux";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useTechnicians } from "../../../../../hooks/useTechnicians";
const { RangePicker } = DatePicker;

export default function SubmissionHead({ setFilter, setCurrentPage }) {
	const inf = useSelector((state) => state.users.user);
	const { setSearchQuery } = useContext(filtrationcontext);
	const { data: FormsData } = useGetAllformsQuery({
		page: 1,
		limit: 1000,
		isActive: true,
	});
	const { data: TasksData } = useGetAllTasksQuery({ page: 1, limit: 1000 });
	const { data: PoisData } = useGetAllPOIsQuery({ page: 1, limit: 1000 });
	const { options } = useTechnicians();
	const [query, setQuery] = useState("");
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};
	const [selectedRange, setSelectedRange] = useState([
		dayjs().startOf("day"),
		dayjs().endOf("day"),
	]);

	return (
		<div>
			<div className="bg-white p-16 d-flex align-items-baseline gap-3">
				<Searchbar
					style="search search-dark input-group"
					path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
					placeholder={trans("Search")}
					value={query}
					onChange={handleSearch}
				/>
				<InputSelect
					placeholder={trans("Forms")}
					options={FormsData?.data?.map((i) => ({
						label: i?.name,
						value: i?.id,
					}))}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(value) => {
						setFilter((prev) => ({ ...prev, formId: value }));
						setCurrentPage(1);
					}}
				/>
				<InputSelect
					placeholder={trans("Tasks")}
					options={TasksData?.data?.map((i) => ({
						label: i?.name,
						value: i?.id,
					}))}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(value) => {
						setFilter((prev) => ({ ...prev, taskId: value }));
						setCurrentPage(1);
					}}
				/>
				<InputSelect
					placeholder={trans("POIs")}
					options={PoisData?.data?.map((i) => ({
						label: i?.name,
						value: i?.id,
					}))}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(value) => {
						setFilter((prev) => ({ ...prev, poiId: value }));
						setCurrentPage(1);
					}}
				/>
				<InputSelect
					placeholder={trans("Submitted By")}
					formstyle="flex-grow-1 text-capitalize"
					options={options}
					onChange={(value) => {
						setFilter((prev) => ({ ...prev, submittedBy: value }));
						setCurrentPage(1);
					}}
				/>
				<RangePicker
					placeholder={[trans("Start Date"), trans("End Date")]}
					onChange={(dates) => {
						if (dates) {
							setSelectedRange(dates);
							setFilter((prev) => ({
								...prev,
								fromDate: dates[0]
									? dates[0].startOf("day").format("YYYY-MM-DDTHH:mm:ss")
									: null,
								toDate: dates[1]
									? dates[1].endOf("day").format("YYYY-MM-DDTHH:mm:ss")
									: null,
							}));
							setCurrentPage(1);
						} else {
							const defaultRange = [
								dayjs().startOf("day"),
								dayjs().endOf("day"),
							];
							setSelectedRange(defaultRange);
							setFilter((prev) => ({
								...prev,
								fromDate: defaultRange[0].format("YYYY-MM-DDTHH:mm:ss"),
								toDate: defaultRange[1].format("YYYY-MM-DDTHH:mm:ss"),
							}));
							setCurrentPage(1);
						}
					}}
					format="YYYY-MM-DDTHH:mm:ss"
					style={{ flexGrow: 1 }}
					allowClear={false}
					showTime={{ format: "HH:mm" }}
				/>
			</div>
		</div>
	);
}
